import styled from "styled-components";
import { Link } from "react-router-dom";
import { theme, typography } from "../Homepage/styles";

export const LegalMain = styled.main`
  padding: 112px 16px 80px;

  @media (max-width: 768px) {
    padding: 104px 16px 64px;
  }
`;

export const LegalInner = styled.div`
  width: 100%;
  max-width: 760px;
  margin: 0 auto;
`;

export const LegalHeader = styled.div`
  margin-bottom: 48px;
  text-align: center;
`;

export const LegalTitle = styled.h1`
  margin: 0 0 12px;
  color: ${theme.foreground};
  font-family: ${typography.fontFamily};
  font-size: 1.875rem; /* text-3xl */
  font-weight: ${typography.weights.bold};
  line-height: 1.2;
  letter-spacing: ${typography.tracking.tight};

  @media (min-width: 768px) {
    font-size: 2.25rem; /* text-4xl */
  }
`;

export const LegalUpdated = styled.p`
  margin: 0;
  color: ${theme.mutedForeground};
  font-family: ${typography.fontFamily};
  font-size: 0.875rem;
  line-height: 1.5;
`;

export const LegalArticle = styled.article`
  font-family: ${typography.fontFamily};
  font-size: 0.9375rem; /* text-[15px] */
  color: ${theme.mutedForeground};
`;

/** Lovable SectionTitle */
export const LegalSectionTitle = styled.h2`
  margin: 48px 0 16px;
  color: ${theme.foreground};
  font-family: ${typography.fontFamily};
  font-size: 1.25rem; /* text-xl */
  font-weight: ${typography.weights.bold};
  line-height: 1.3;
  letter-spacing: ${typography.tracking.tight};

  &:first-child {
    margin-top: 0;
  }

  @media (min-width: 768px) {
    font-size: 1.5rem; /* text-2xl */
  }
`;

/** Lovable SubTitle */
export const LegalSubTitle = styled.h3`
  margin: 24px 0 12px;
  color: ${theme.foreground};
  font-family: ${typography.fontFamily};
  font-size: 1rem; /* text-base */
  font-weight: ${typography.weights.semibold};
  line-height: 1.4;

  @media (min-width: 768px) {
    font-size: 1.125rem; /* text-lg */
  }
`;

export const LegalParagraph = styled.p`
  margin: 0 0 16px;
  color: ${theme.mutedForeground};
  font-size: 0.9375rem;
  line-height: 1.75; /* leading-7 */
`;

export const LegalNotice = styled.p`
  margin: 0 0 24px;
  color: ${theme.foreground};
  font-size: 0.9375rem;
  font-weight: ${typography.weights.semibold};
  line-height: 1.75;
  text-transform: uppercase;
`;

export const LegalInlineLink = styled(Link)`
  color: ${theme.primary};
  text-decoration: underline;
  text-underline-offset: 4px;
  text-decoration-color: hsl(var(--hp-primary) / 0.4);
  transition: text-decoration-color 0.2s ease;

  &:hover {
    color: ${theme.primary};
    text-decoration-color: ${theme.primary};
  }
`;

export const LegalExternalLink = styled.a`
  color: ${theme.primary};
  text-decoration: underline;
  text-underline-offset: 4px;
  text-decoration-color: hsl(var(--hp-primary) / 0.4);
  transition: text-decoration-color 0.2s ease;

  &:hover {
    color: ${theme.primary};
    text-decoration-color: ${theme.primary};
  }
`;

export const LegalBackWrap = styled.div`
  margin-top: 64px;
  padding-top: 32px;
  border-top: 1px solid hsl(var(--hp-border) / 0.6);
  text-align: center;
`;

export const LegalBackButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 18px;
  border: 1px solid ${theme.border};
  border-radius: var(--hp-radius-md, calc(var(--hp-radius, 0.75rem) - 2px));
  background: transparent;
  color: ${theme.foreground};
  font-family: ${typography.fontFamily};
  font-size: 0.875rem;
  font-weight: ${typography.weights.medium};
  line-height: 1;
  cursor: pointer;
  transition:
    border-color 0.15s ease,
    background 0.15s ease,
    color 0.15s ease;

  &:hover {
    border-color: hsl(var(--hp-primary) / 0.45);
    background: hsl(var(--hp-primary) / 0.08);
    color: ${theme.primary};
  }

  svg {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }
`;
